export { default as Image1 } from './alex-motoc-0POwK6iAiRQ-unsplash.jpg';
export { default as Image1Thumb } from './alex-motoc-0POwK6iAiRQ-unsplash-thumb.jpg';
export { default as Image2 } from './c-d-x-PDX_a_82obo-unsplash.jpg';
export { default as Image2Thumb } from './c-d-x-PDX_a_82obo-unsplash-thumb.jpg';
export { default as Image3 } from './irene-kredenets-dwKiHoqqxk8-unsplash.jpg';
export { default as Image3Thumb } from './irene-kredenets-dwKiHoqqxk8-unsplash-thumb.jpg';
export { default as Image4 } from './joan-tran-reEySFadyJQ-unsplash.jpg';
export { default as Image4Thumb } from './joan-tran-reEySFadyJQ-unsplash-thumb.jpg';
export { default as Image5 } from './kiran-ck-6rXpQzfCYlw-unsplash.jpg';
export { default as Image5Thumb } from './kiran-ck-6rXpQzfCYlw-unsplash-thumb.jpg';
export { default as Image6 } from './kiran-ck-7KMhZqylgss-unsplash.jpg';
export { default as Image6Thumb } from './kiran-ck-7KMhZqylgss-unsplash-thumb.jpg';
export { default as Image7 } from './kiran-ck-cDrIiiptFqE-unsplash.jpg';
export { default as Image7Thumb } from './kiran-ck-cDrIiiptFqE-unsplash-thumb.jpg';
export { default as Image8 } from './kiran-ck-lSl94SZHRgA-unsplash.jpg';
export { default as Image8Thumb } from './kiran-ck-lSl94SZHRgA-unsplash-thumb.jpg';
export { default as Image9 } from './kiran-ck-LSNJ-pltdu8-unsplash.jpg';
export { default as Image9Thumb } from './kiran-ck-LSNJ-pltdu8-unsplash-thumb.jpg';
export { default as Image10 } from './kiran-ck-RZmiDOpv1lM-unsplash.jpg';
export { default as Image10Thumb } from './kiran-ck-RZmiDOpv1lM-unsplash-thumb.jpg';
export { default as Image11 } from './kiran-ck-x_BppzRCBLs-unsplash.jpg';
export { default as Image11Thumb } from './kiran-ck-x_BppzRCBLs-unsplash-thumb.jpg';
export { default as Image12 } from './mae-mu-GnWKTJlMYsQ-unsplash.jpg';
export { default as Image12Thumb } from './mae-mu-GnWKTJlMYsQ-unsplash-thumb.jpg';
export { default as Image13 } from './mike-meyers-v8XaVfyo41Q-unsplash.jpg';
export { default as Image13Thumb } from './mike-meyers-v8XaVfyo41Q-unsplash-thumb.jpg';
export { default as Image14 } from './mohammad-metri-E-0ON3VGrBc-unsplash.jpg';
export { default as Image14Thumb } from './mohammad-metri-E-0ON3VGrBc-unsplash-thumb.jpg';
export { default as Image15 } from './rachit-tank-2cFZ_FB08UM-unsplash.jpg';
export { default as Image15Thumb } from './rachit-tank-2cFZ_FB08UM-unsplash-thumb.jpg';
export { default as Image16 } from './eniko-kis-KsLPTsYaqIQ-unsplash.jpg';
export { default as Image16Thumb } from './eniko-kis-KsLPTsYaqIQ-unsplash-thumb.jpg';
export { default as Image17 } from './marius-masalar-2rm8p0rKXiw-unsplash.jpg';
export { default as Image17Thumb } from './marius-masalar-2rm8p0rKXiw-unsplash-thumb.jpg';
export { default as Image18 } from './milena-trifonova-pHqt1DsHCx0-unsplash.jpg';
export { default as Image18Thumb } from './milena-trifonova-pHqt1DsHCx0-unsplash-thumb.jpg';
export { default as Image19 } from './norbert-levajsics-dUx0gwLbhzs-unsplash.jpg';
export { default as Image19Thumb } from './norbert-levajsics-dUx0gwLbhzs-unsplash-thumb.jpg';
export { default as Image20 } from './erica-steeves-G_lwAp0TF38-unsplash.jpg';
export { default as Image20Thumb } from './erica-steeves-G_lwAp0TF38-unsplash-thumb.jpg';
export { default as Image21 } from './thought-catalog-o0Qqw21-0NI-unsplash.jpg';
export { default as Image21Thumb } from './thought-catalog-o0Qqw21-0NI-unsplash-thumb.jpg';
export { default as Image22 } from './rianne-zuur-aeGLb-6DPp8-unsplash.jpg';
export { default as Image22Thumb } from './rianne-zuur-aeGLb-6DPp8-unsplash-thumb.jpg';
export { default as Image23 } from './anomaly-oRskqiH7FNc-unsplash.jpg';
export { default as Image23Thumb } from './anomaly-oRskqiH7FNc-unsplash-thumb.jpg';
export { default as Image24 } from './florian-klauer-mk7D-4UCfmg-unsplash.jpg';
export { default as Image24Thumb } from './florian-klauer-mk7D-4UCfmg-unsplash-thumb.jpg';
export { default as Image25 } from './isabella-fischer-6ast1xZ9YJY-unsplash.jpg';
export { default as Image25Thumb } from './isabella-fischer-6ast1xZ9YJY-unsplash-thumb.jpg';
export { default as Image26 } from './sincerely-media-0KwFuwdW7pU-unsplash.jpg';
export { default as Image26Thumb } from './sincerely-media-0KwFuwdW7pU-unsplash-thumb.jpg';
export { default as Image27 } from './nayam-27twCoUEAPM-unsplash.jpg';

export { default as UserBrain } from './milad-fakurian-58Z17lnVS4U-unsplash.jpg';
export { default as UserBrainThumb } from './milad-fakurian-58Z17lnVS4U-unsplash-thumb.jpg';

export { default as User1 } from './avatar/user1.png';
export { default as User1Thumb } from './avatar/user1-thumb.png';
export { default as User2 } from './avatar/user2.png';
export { default as User2Thumb } from './avatar/user2-thumb.png';
export { default as User3 } from './avatar/user3.png';
export { default as User3Thumb } from './avatar/user3-thumb.png';
export { default as User4 } from './avatar/user4.png';
export { default as User4Thumb } from './avatar/user4-thumb.png';
export { default as User5 } from './avatar/user5.png';
export { default as User5Thumb } from './avatar/user5-thumb.png';
export { default as User6 } from './avatar/user6.png';
export { default as User6Thumb } from './avatar/user6-thumb.png';
export { default as User7 } from './avatar/user7.png';
export { default as User7Thumb } from './avatar/user7-thumb.png';
export { default as User8 } from './avatar/user8.png';
export { default as User8Thumb } from './avatar/user8-thumb.png';
export { default as User9 } from './avatar/user9.png';
export { default as User9Thumb } from './avatar/user9-thumb.png';

export { default as DeliveryMan1 } from './humans/delivery_man_1.png';
export { default as DeliveryMan5WithDog } from './humans/delivery_man_5_with_dog.png';

export { default as FastbuyLogo } from './fastbuy/fastbuy-logo.png';
export { default as FastbuyMascot } from './fastbuy/fastbuy-mascot.png';
export { default as FastbuyMascotSorry } from './fastbuy/fastbuy-mascot-sorry.png';

export { default as TutorialFastbuy } from './tutorial_Fastbuy.png';
export { default as ShoppingBag } from './shopping-bag.png';
export { default as Package } from './package.png';